module.exports = __webpack_public_path__ + "img/english.a18d0057.png";